export default "M 20.25 5.012 L 24 5.012 L 24 19.012 L 20.25 19.012 Z M 5.75 3.25 L 18.25 3.25 L 18.25 20.75 L 5.75 20.75 Z M 0 5 L 3.75 5 L 3.75 19 L 0 19 Z";